<template>
  <div class="s_chat_right_quick g-flex-column">
      <!-- 左边树形 -->
      <div class="v-quick-rep-left-content">
        <el-tree @node-click="quickItemClick"  class="v-custom-tree" :data="treeData" node-key="id" :props="menu_props" default-expand-all :check-on-click-node="true" :expand-on-click-node="true">
          <div class="v-custom-tree-node g-flex-align-center" slot-scope="{ node, data }">
            <!-- 主题 -->
            <span class="v-tree-label-name">{{ node.label }}</span>
            <!-- 消息 -->
             <el-tooltip popper-class="v-tree-quick-tooltip" class="item" effect="dark" :content="data.msg" placement="top" v-if="data.msg">
                <div class="v-tree-item-msg">{{data.msg}}</div>
            </el-tooltip>
          </div>
        </el-tree>
      </div>

  </div>
</template>

<script>
  import Bus from '@/utils/bus.js'
  import { apiGetReplyList, apiReplySort } from '@/utils/api.js'
  export default {
    data() {
      return {
        searchVal: '',
        quickMsgList: [],

        searchMsgList: [],
        
        showList: true,

        treeData: [],

        menu_props: {
          children: 'children',
          label: 'title'
        }
      }
    },
    created() {
      this.getList()
    },
    methods: {
    // 获取列表
    async getList() {
      const { success, data } = await apiGetReplyList()
      if(!success) return
      this.treeData = this.dealTreeData(data.list, 0)
      // console.log('list', this.treeData)
    },

    // 处理数据
    dealTreeData(MenuArr, parent_id) {
      let reqList = []
      MenuArr.forEach(item => {
        if(item.parent_id == parent_id) {
          let children = this.dealTreeData(MenuArr, item.id)
          if(children.length > 0) item.children = children
          reqList.push(item)  
        }
      })
      return reqList
    },

    //搜索
    inputSeach(val) {
      if(!val) return this.showList = true
      this.searchMsgList = this.quickMsgList.filter(item => {
        return item.msg.indexOf(val) !== -1
      })
      this.showList = false
    },

    // 点击快捷消息
    quickItemClick(data) {
      Bus.$emit('busQuickItem', data)
    },


    // 上移
    async upItemClick(item, index) {
      if(index === 0) return
      const { success } = await apiReplySort({ id: item.id, jh_id: this.quickMsgList[index-1].id})
      if(!success) return
      this.quickMsgList.splice(index - 1, 0, item)
      this.quickMsgList.splice(index + 1, 1)
    },

    // 下移
    async downItemClick(item, index) {
      if(index === this.quickMsgList.length - 1) return
      const { success } = await apiReplySort({ id: item.id, jh_id: this.quickMsgList[index+1].id})
      if(!success) return
      this.quickMsgList.splice(index + 2, 0, item)
      this.quickMsgList.splice(index, 1)
    },  
    }
  }
</script>

<style lang="scss">
.s_chat_right_quick {
  height: 100%;
  .el-button--primary {
    background: $mainBlue;
  }
  .s-quick-search {
    padding: 10px 10px 6px 10px;
    .s-add-btn {
      margin-top: 10px;
      width: 100%;
      background: $mainBlue;
    }
  }
  // 树形
  .v-quick-rep-left-content {
    margin-top: 20px;
    background: $white;
    .v-custom-tree {
      width: 100%;
      .el-tree-node__content {
        height: 36px;
      }
      .v-custom-tree-node {
        width: 100%;
        .v-tree-label-name {
          font-size: $small-more-font-size;
        }
        .v-tree-item-msg {
          flex: 1;
          padding-left: 10px;
          font-size: $most-font-size;
          color: #858e99;
          width: 200px;
          @include textEllipsis();
        }
      }
    }
  }

  .s-quick-search-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    .s-quick-search-item {
      cursor: pointer;
      padding: 15px 0;
      border-bottom: 1px solid $chatContainerBg;
      font-size: $most-font-size;
      p {
        flex: 1;
        color: $fontColor;
        padding-left: 10px;
        @include textEllipsis();
        word-break: break-all;
      }
    }
  }
}

.el-popconfirm {
  .el-popconfirm__action {
    text-align: center;
    padding-top: 10px;
  }
}

.v-tree-quick-tooltip {
  max-width: 300px;
  line-height: 20px;
}

</style>